import { useMutation } from '@tanstack/react-query'
import { putAccountPreference } from 'services/AccountService'

export const useAccountPreferenceMutation = <T>() => {
  return useMutation({ mutationFn: putAccountPreference<T> })
}
